<div class="col-12 mb-3" id="announcements">
  <s9-announcement-list [announcements]="announcements$ | async">
  </s9-announcement-list>
</div>
